import { gql } from '@apollo/client';

export const FETCH_FILE_SYSTEM_OBJECTS = gql`
    query fetchFileSystemObjects($filter: FileSystemObjectFilter) {
        facility {
            files(filter: $filter) {
                name
                size
                isAFolder
                utcLastModifiedTime
                mimeType
                storageClass
                isViewable
                uri
            }
        }
    }
`;
